import { ctaLineSchema } from "../components/CtaLine.sanity";
import { linkUrlGroq } from "../sanity/schemas/link";
import { validate } from "../sanity/utils/validate";

export const sectorInfoSchema = {
  type: "object",
  name: "sectorInfo",
  fields: [
    {
      name: "title",
      type: "string",
      validation: validate({ required: true }),
    },
    {
      name: "text",
      type: "text",
      rows: 3,
      validation: validate({ required: true }),
    },
    {
      name: "image",
      type: "figure",
      validation: validate({ required: true }),
    },
    {
      name: "items",
      type: "array",
      of: [
        {
          type: "object",
          fields: [
            {
              name: "title",
              type: "string",
            },
            {
              name: "text",
              type: "text",
            },
          ],
        },
      ],
    },
    {
      name: "cta",
      title: "CTA Line",
      type: "ctaLine",
    },
  ],
};

export const sectorInfoGroq = `
  ...,
  "cta": cta{
    ...,
    "url": ${linkUrlGroq}
  }
`;
